import { WidgetChartOptions } from 'app/modules/widget/components/widget-chart/widget-chart.component';
import { Dashboard, Widget } from 'app/providers/bridge-api/dashboard.service';
import { AbstractDocumentsChartReport } from '../chart-report-abstract/chart-report-abstract';

export class BigNumberDocumentsReport extends AbstractDocumentsChartReport {
  public reportName = 'documentSentimentPolarity';
  public reportHandler = (
    _dashboard: Dashboard,
    _widget: Widget<WidgetChartOptions>,
    _response: any,
    _options: any
  ) => ({});

  isAnalyticItemSupported(analyticItem) {
    return ['documents', 'metadata'].indexOf(analyticItem) > -1;
  }

  public async processResponse(
    report: any,
    _filterQuery?: string
  ): Promise<{ docs: number; result: number }> {
    const ret = {
      docs: 0,
      result: 0,
    };

    if (report.items.count.document_sentiment_polarity) {
      ret.result = Object.values(report.items.count.document_sentiment_polarity).reduce<number>(
        (prev: number, curr: number) => prev + curr,
        0
      );
      ret.docs = ret.result;
    }

    return ret;
  }
}
